import dynamic from 'next/dynamic';
import React from 'react';

const Login = dynamic(() => import('@members/pg-auth/Login'), {
  ssr: false,
});

export default function LoginPage() {
  return <Login />;
}
